<template>
  <div class="container-fluid p-0">
    <div class="row no-gutters">
      <div class="col-sm-12 text-center">
        <div class="unsubscribe-wrapper">
          <h2 class="mb-0">Are you sure you want to unsubscribe?</h2>
          <h1>{{ email }}</h1>
          <div v-if="state === 'INIT' || state === 'LOADING'">
            <p>Click UNSUBSCRIBE button below to proceed.</p>
            <button
              @click="unsubscribe()"
              class="btn btn-primary mt-3"
              :disabled="state === 'LOADING'"
            >
              UNSUBSCRIBE
            </button>
          </div>
          <h2 v-if="state === 'SUCCESS'" class="text-success">
            Email successfully unsubscribed.
          </h2>
          <h2 v-if="state === 'ERROR'" class="text-danger">
            Failed to unsubscribe.
          </h2>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const STATE_INIT = "INIT";
const STATE_LOADING = "LOADING";
const STATE_SUCCESS = "SUCCESS";
const STATE_ERROR = "ERROR";

export default {
  name: "Unsubscribe",
  data() {
    return {
      state: STATE_INIT,
      error: null
    };
  },
  methods: {
    async unsubscribe() {
      this.state = STATE_LOADING;
      fetch(this.unsubscribeLink)
        .then(() => {
          this.state = STATE_SUCCESS;
        })
        .catch(() => {
          this.state = STATE_ERROR;
          this.error = "Failed to unsubscribe.";
        });
    }
  },
  computed: {
    email() {
      if (this?.$route?.query?.email) {
        return this.$route.query.email;
      }
      return "";
    },
    unsubscribeLink() {
      if (this?.$route?.query?.unsubscribeLink) {
        let url = this.$route.query.unsubscribeLink;
        if (!/^https?:\/\//i.test(url)) {
          url = "http://" + url;
        }
        return url;
      }
      return "";
    }
  }
};
</script>

<style scoped>
.unsubscribe-wrapper {
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.unsubscribe-wrapper h1 {
  font-size: 5rem;
}
</style>
